export default __webpack_public_path__ + "static/media/glove_superwarm.a45f67e1.jpg";